<script setup>

import {reactive, ref} from "vue";
    import {useRouter, useRoute} from "vue-router";
    import {useAuthStore} from "../../store/auth.js";
import ErrorBar from "../../components/global/ErrorBar.vue";

    const router = useRouter()
    const route = useRoute()

    const store = useAuthStore()
    const error = ref('')

    const credentials = reactive({
        email: '',
        password: ''
    })

    const login = async () => {
        error.value = ''
        try {
            await store.login(credentials)
            await router.push(route.query.r ? route.query.r : '/')
        }

        catch (e) {
            console.log(e)
            switch (e.response.status) {
                case 401:
                    error.value = 'Invalid credentials. Please try again.'
                    break
                default:
                    error.value = 'Something went wrong. Please try again.'
            }
        }
    }

</script>

<template>
    <main class="auth">

        <img class="logo" src="/public/internal/images/logo-vertical.png" srcset="/public/internal/images/logo-vertical@2x.png 2x" alt="">

        <form @submit.prevent="login" class="auth-form">
            <brand-form-input label="Email address." variant="email" v-model="credentials.email" />
            <brand-form-input label="Password." variant="password" v-model="credentials.password" />
<!--            <input type="email" placeholder="email" v-model="credentials.email">-->
<!--            <input type="password" placeholder="password" v-model="credentials.password">-->
            <error-bar :error="error" />
            <button type="submit">Login</button>
        </form>
        <router-link class="link-forgot" to="/auth/forgot">Forgot password?</router-link>
    </main>
</template>
